"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _Text = _interopRequireDefault(require("../../Text"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1y1g4zu-SubSection",
  styles: "font-weight:800;;label:SubSection;"
} : {
  name: "1y1g4zu-SubSection",
  styles: "font-weight:800;;label:SubSection;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSm9iQ2FyZC9EZXNjcmlwdGlvbi9TdWJTZWN0aW9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFlbUQiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL1Jlc3BvbnNpdmVKb2JDYXJkL0Rlc2NyaXB0aW9uL1N1YlNlY3Rpb24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IEZ1bmN0aW9uQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgRmxleCwgeyBGbGV4UHJvcHMgfSBmcm9tICcuLi8uLi9GbGV4JztcbmltcG9ydCBUZXh0LCB7IFRleHRQcm9wcyB9IGZyb20gJy4uLy4uL1RleHQnO1xuXG5leHBvcnQgaW50ZXJmYWNlIFN1YlNlY3Rpb25Qcm9wcyBleHRlbmRzIEZsZXhQcm9wczwnZGl2Jz4ge1xuICB0aXRsZT86IHN0cmluZztcbiAgVGV4dFByb3BzPzogVGV4dFByb3BzPCdzcGFuJz47XG59XG5cbmNvbnN0IFN1YlNlY3Rpb246IEZ1bmN0aW9uQ29tcG9uZW50PFN1YlNlY3Rpb25Qcm9wcz4gPSAocHJvcHMpID0+IHtcbiAgY29uc3QgeyB0aXRsZSwgVGV4dFByb3BzLCBjaGlsZHJlbiwgLi4ub3RoZXIgfSA9IHByb3BzO1xuXG4gIHJldHVybiAoXG4gICAgPEZsZXggZmxleERpcmVjdGlvbj1cImNvbHVtblwiIHsuLi5vdGhlcn0+XG4gICAgICA8VGV4dCBhcz1cImgzXCIgdmFyaWFudD1cImhlYWRsaW5lNFwiIGd1dHRlcj17Mn0gY3NzPXt7IGZvbnRXZWlnaHQ6IDgwMCB9fSB7Li4uVGV4dFByb3BzfT5cbiAgICAgICAge3RpdGxlfVxuICAgICAgPC9UZXh0PlxuICAgICAge2NoaWxkcmVufVxuICAgIDwvRmxleD5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFN1YlNlY3Rpb247XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var SubSection = function SubSection(props) {
  var title = props.title,
      TextProps = props.TextProps,
      children = props.children,
      other = (0, _objectWithoutProperties2["default"])(props, ["title", "TextProps", "children"]);
  return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    flexDirection: "column"
  }, other), (0, _core.jsx)(_Text["default"], (0, _extends2["default"])({
    as: "h3",
    variant: "headline4",
    gutter: 2,
    css: _ref
  }, TextProps), title), children);
};

var _default = SubSection;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(SubSection, "SubSection", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Description/SubSection.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Description/SubSection.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();